import React from "react"

import Header from "../../components/Header"
import NavigationButtons from "../../components/NavigationButtons"
import Input from "../../components/Input/Input"

import styles from "../../css/Page.module.css"

const HasSubscription = props => {
  return (
    <div>
      <Header title="Kan det finnas bindningstid?" />
      <div className={styles.inputContainer}>
        <Input
          name="hasSubscriptionChoice"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
        />
      </div>
      {/*<NavigationButtons
        inputState={props.inputState}
  />*/}
    </div>
  )
}
  
export default HasSubscription